import { z } from "zod";

const MAP_TYPES = ["roadmap", "satellite", "highres", "highresnz"] as const;
// User map type schema
const mapTypeSchema = z.enum(MAP_TYPES);
type MapType = z.infer<typeof mapTypeSchema>;
const MAP_TYPE = Object.freeze(
  Object.fromEntries(MAP_TYPES.map(v => [v.toUpperCase(), v]))
) as Record<Uppercase<MapType>, MapType>;

// User role schema
const userRoleSchema = z.enum([
  "government",
  "superadministrator",
  "administrator",
  "staff",
  "default",
]);
type UserRole = z.infer<typeof userRoleSchema>;

const USER_SCHEMA = z.object({
  id: z.number(),
  email: z.string().nullish(),
  profession: z.string().nullish(),
  full_name: z.string().nullish(),
  phone: z.string().nullish(),
  design_software: z.array(z.string()).nullish(),
  role: userRoleSchema,
  is_anonymous: z.boolean(),

  customer: z
    .object({
      id: z.string(),
      memberships: z.array(
        z.object({
          id: z.string(),
          status: z.string(),
          trial_end: z.string(),
          name: z.string(),
          cancel_date: z.string().nullish(),
          end_date: z.string(),
          discounts: z
            .object({
              data: z.number().nullish(),
            })
            .nullish(),
        })
      ),
    })
    .nullish(),
});
type UserT = z.infer<typeof USER_SCHEMA>;

export {
  MAP_TYPES,
  MAP_TYPE,
  mapTypeSchema,
  type MapType,
  userRoleSchema,
  type UserRole,
  USER_SCHEMA,
  type UserT,
};
